export default __webpack_public_path__ + "static/media/raptor-tablet.b35a49c0.png";